import Vue from 'vue'
import Decimal from 'decimal.js';// 使用 decimal.js 或 bignumber.js 处理高精度金额

Vue.filter('formatAmount', (value) => {
  // 数据为空
  if (!value) return '0.00';

  //
  let floatPart = '.00'; // 预定义小数部分
  let value2Array = value.toString().split('.');
  if (value2Array.length == 2) { // =2表示数据有小数位
    floatPart = value2Array[1].toString(); // 拿到小数部分
    if (floatPart.length == 1) { // 补0
      return value2Array[0] + '.' + floatPart + '0';
    } else { // 多位小数四舍五入后只保留2位
      return parseFloat(value).toFixed(2);
    }
  } else { // 无小数位
    return value2Array[0] + floatPart;
  }
})

//高精度计算
Vue.filter('formatDecimalAmount', (value) => {
  if (!value) return '0.00';
  return new Decimal(value).toFixed(2);
})


// WEBPACK FOOTER //
// ./src/util/amountFilter.js